module.exports = __webpack_public_path__ + "img/top-sub-2.3bfd06e.png";